import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'old-store/store';
import { selectImages } from 'store/slices/images/selectors';

export const selectUsesNewGallerySelection = (state: RootState) =>
  state.collection.collectionCreator?.featureFlags?.newDesign === true;

export const selectActiveSelectionState = (state: RootState) =>
  selectUsesNewGallerySelection(state) ? state.scrAppBookNew.selection : state.selection;

export const selectActiveSelections = createSelector(
  selectActiveSelectionState,
  (selection) => selection.all
);

export const selectActiveAllUserSelections = createSelector(
  selectActiveSelectionState,
  (selection) => selection.allUserSelections
);

export const selectActiveSortedSelections = createSelector(
  selectActiveSelections,
  (selections = []) =>
    [...selections].sort(
      (first, second) => new Date(second.updatedAt).getTime() - new Date(first.updatedAt).getTime()
    )
);

export const selectActiveSortedAllUserSelections = createSelector(
  selectActiveAllUserSelections,
  (selections = []) =>
    [...selections].sort(
      (first, second) => new Date(second.updatedAt).getTime() - new Date(first.updatedAt).getTime()
    )
);

export const selectActiveLikedImages = createSelector(
  selectActiveSelectionState,
  selectImages,
  (selection, images) =>
    images
      .filter((image) => selection.likes.includes(image._id))
      .sort(
        (first, second) => selection.likes.indexOf(first._id) - selection.likes.indexOf(second._id)
      )
);
